const destinationPath = (page, params = {}) => {
  if (page === 'admin-ai-pending') return '/ai/pending';
  if (page === 'admin-ai-catalog') return '/ai/catalog';
  if (page !== 'api-detail') return '/review';

  const search = new URLSearchParams();
  if (params.id) search.set('apiId', params.id);
  if (params.version) search.set('version', params.version);
  const query = search.toString();
  return `/review${query ? `?${query}` : ''}`;
};

export const adminConsoleOrigin = (hostname) => {
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5101';
  }
  if (hostname === 'test.xapi.to' || hostname.endsWith('.test.xapi.to')) {
    return 'https://admin.test.xapi.to';
  }
  return 'https://admin.xapi.to';
};

export const adminConsoleUrl = (page, hostname, params) =>
  `${adminConsoleOrigin(hostname)}${destinationPath(page, params)}`;
